// useLoadingBar.tsx
import { useEffect, useMemo, useRef, useState } from "react";

export function useProgress(isLoading: boolean) {
	const [progress, setProgress] = useState(0);

	// longer on 99 then 2 seconds
	const progressInterval = useRef<NodeJS.Timeout | null>(null);

	const [isLongerThan2Seconds, setIsLongerThan2Seconds] = useState(false);

	useEffect(() => {
		if (progress === 99) {
			progressInterval.current = setTimeout(() => {
				setIsLongerThan2Seconds(true);
			}, 2000);
		}

		return () => {
			if (progressInterval.current) {
				clearTimeout(progressInterval.current);
			}
		};
	}, [progress]);

	const funnyTexts = [
		"Finding the person on LinkedIn...",
		"Checking the current employer of the person...",
		"Checking the previous employers of the person...",
		"Analysing the gender of the person...",
		"Analysing the location of the person...",
		"Analysing the seniority of the person...",
		"Analysing the company of the person...",
	];

	const currentFunnyText = useMemo(() => {
		if (isLongerThan2Seconds) {
			return "It seems to take longer than expected... We're still working on it...";
		}

		return funnyTexts[Math.floor(progress / (100 / funnyTexts.length))];
	}, [progress, funnyTexts, isLongerThan2Seconds]);

	useEffect(() => {
		if (!isLoading) {
			// finish quickly
			setProgress(100);
			const timeout = setTimeout(() => setProgress(0), 500);

			return () => clearTimeout(timeout);
		}

		setProgress(0);
		let current = 0;

		const interval = setInterval(() => {
			// go fast in the beginning, slower later, never reach 100
			current = Math.min(current + Math.random() * 3, 99);
			setProgress(Math.round(current));
		}, 200);

		return () => clearInterval(interval);
	}, [isLoading]);

	return { progress, currentFunnyText };
}
